import { render, staticRenderFns } from "./MenuPoint.vue?vue&type=template&id=77cbed86&"
import script from "./MenuPoint.vue?vue&type=script&lang=js&"
export * from "./MenuPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports